import {Component, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class ModalMixin extends Vue {
	modalName: string = 'default-modal';
	isExplicit: boolean = true;

	get activeModal(): string | null {
		return this.$store.state.activeModal;
	}

	get modalVisible(): boolean {
		return !!this.activeModal;
	}

	get actualWindowWidth(): number {
		return this.$store.state.global.width;
	}

	get isModalActive(): boolean {
		if (!this.$store.state.activeModal) {
			return false;
		}
		return this.$store.state.activeModal.length > 0;
	}

	@Watch('actualWindowWidth')
	async onActualWindowWidthChanged(newValue: number, oldValue: number): Promise<void> {
		if (newValue === oldValue || this.isExplicit) {
			return;
		}

		if (newValue < 901 && oldValue > 900 && this.modalName === this.activeModal) {
			await this.$store.dispatch('hideModals');
		}

	}

	async toggleModal(name: string | MouseEvent): Promise<void> {

		if (typeof name !== 'string') {
			name = this.modalName;
		}

		if (this.activeModal && this.activeModal !== name) {
			await this.$store.dispatch('hideModals');
			await this.$store.dispatch('showModal', name);

			return;
		}

		if (this.activeModal && this.activeModal === name) {
			await this.$store.dispatch('hideModals');
			return;
		}

		await this.$store.dispatch('showModal', name);

	}
}
